"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnifiedSearchTileGrid;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _productListingContext = require("../../elements/other/product-list-page/product-listing-context");
var _spinner = _interopRequireDefault(require("../../elements/other/spinner"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _unifiedSearchComponent = _interopRequireDefault(require("./unified-search-component"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const TileSectionWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileSectionWrapper",
  class: "pl-t1mn2yid",
  vars: {
    "t1mn2yid-0": [({
      dynamicHeight
    }) => dynamicHeight]
  }
});
const TileSection = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileSection",
  class: "pl-tm3tzzt"
});
const TileGrid = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TileGrid",
  class: "pl-t1my92un"
});
const Tile = /*#__PURE__*/(0, _react2.styled)(_unifiedSearchComponent.default)({
  name: "Tile",
  class: "pl-t1okb8u5",
  vars: {
    "t1okb8u5-0": [({
      hide
    }) => hide ? 'none' : 'flex']
  }
});
const MarkdownComponent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarkdownComponent",
  class: "pl-m3a9vby"
});

/**
 * Render the product tile grid.
 * @memberof module:ProductListingSection
 * @param {object} props React props
 * @param {number} props.tilesPerPage Number of tiles to display
 * @param {object} props.tileGridRef Pagination text
 * @param {string} props.containerHeight Pagination text
 * @returns {React.ReactElement} Product tile grid
 */
function UnifiedSearchTileGrid({
  results,
  isLoading,
  tileGridRef,
  containerHeight,
  iaMarkdown
}) {
  const {
    isActiveTagFilter,
    tagFilterValue
  } = (0, _react.useContext)(_productListingContext.ProductListingContext);
  const [renderedTiles, setRenderedTiles] = (0, _react.useState)(results);
  (0, _react.useEffect)(() => {
    if (isActiveTagFilter) {
      const filteredTiles = results.filter(tile => {
        const trackTag = tile?.trackTag?.toLowerCase();
        return trackTag === tagFilterValue.toLowerCase();
      });
      setRenderedTiles(filteredTiles);
    } else {
      setRenderedTiles(results);
    }
  }, [isActiveTagFilter, tagFilterValue, results]);
  return /*#__PURE__*/_react.default.createElement(TileSectionWrapper, {
    dynamicHeight: containerHeight
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg",
    centerHorizontally: true
  }) : /*#__PURE__*/_react.default.createElement(TileSection, {
    "data-cy": "tile-section"
  }, /*#__PURE__*/_react.default.createElement(TileGrid, {
    ref: tileGridRef
  }, iaMarkdown?.length > 0 && /*#__PURE__*/_react.default.createElement(MarkdownComponent, null, /*#__PURE__*/_react.default.createElement("h2", null, "AI Recommended")), renderedTiles?.map((tile, i) => /*#__PURE__*/_react.default.createElement(Tile, {
    key: i,
    gridIndex: i,
    variant: tile.componentType ?? 'plComponent',
    resultType: tile.resultType,
    iaMarkdown: tile.iaMarkdown,
    iaRecommended: tile.iaRecommended,
    args: tile.props
  })))));
}
UnifiedSearchTileGrid.propTypes = {
  isLoading: _propTypes.default.bool,
  tileGridRef: _propTypes.default.object,
  containerHeight: _propTypes.default.string,
  results: _propTypes.default.array,
  iaMarkdown: _propTypes.default.string
};